"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarReflectors = void 0;
var Tags_1 = require("../Tags");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var SolarReflectors = (function (_super) {
    __extends(SolarReflectors, _super);
    function SolarReflectors() {
        return _super.call(this, {
            cost: 23,
            tags: [Tags_1.Tags.SPACE],
            name: CardName_1.CardName.SOLAR_REFLECTORS,
            cardType: CardType_1.CardType.AUTOMATED,
            metadata: {
                cardNumber: 'C38',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(5).digit; });
                }),
                description: 'Increase your heat production 5 steps.',
            },
        }) || this;
    }
    SolarReflectors.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 5);
        return undefined;
    };
    return SolarReflectors;
}(Card_1.Card));
exports.SolarReflectors = SolarReflectors;
//# sourceMappingURL=SolarReflectors.js.map